export default __webpack_public_path__ + "static/media/28.9c9dce32.mp3";